<template>
    <div class="test-view-page" :class='{"live-test-hide-nav": isTestStarted}'>
        <v-app id="dashboard-view-test">
            <Toolbar class="test-toolbar"/>
            <Drawer class="test-drawer"/>
			<VideoSlidePanel/>

            <v-container fill-height class="dashboard-main-view-test header-fix-cp3 preview-test-cp3" :class="{'preview-test-background':checkRouteName()}">
                <router-view></router-view>
            </v-container>
        </v-app>
    </div>
</template>

<script>
import Toolbar from '@/components/core/Toolbar.vue'
import Drawer from '@/components/core/Drawer.vue'
import VideoSlidePanel from "@/components/core/VideoSlidePanel.vue";

import { mapState } from "vuex";

export default {
    name: 'TestView',
    components: {
        Toolbar,
        Drawer,
		VideoSlidePanel
    },
    data() {
        return {
            
        }
    },
   methods: {
       checkRouteName(){
           return this.$route.name=='preview-myt-test' ? true : false
       }
   },
    computed: {
		...mapState('testStore', ['isTestStarted']),
	},
    
    

}
</script>

